import { render, staticRenderFns } from "./secondCard.vue?vue&type=template&id=61b690f6&scoped=true&"
import script from "./secondCard.vue?vue&type=script&lang=js&"
export * from "./secondCard.vue?vue&type=script&lang=js&"
import style0 from "./secondCard.vue?vue&type=style&index=0&id=61b690f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b690f6",
  null
  
)

export default component.exports